<template>
  <div class="home">
    <Header/>
    <VideoFram></VideoFram>
    <kurse-home></kurse-home>
    <Footer></Footer>
  </div>
</template>

<script lang="ts">
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'
import Footer from '@/components/Footer.vue'
import Header from '@/components/Header.vue'
import VideoFram from '@/components/home/VideoFram.vue'
import CoursesHome from '@/components/home/coursesHome.vue'

@Component({
  components: {
    KurseHome: CoursesHome,
    Footer,
    Header,
    VideoFram
  }
})
export default class HomeView extends Vue {}
</script>
